import React from 'react';
import classNames from 'classnames';
import uikit from '../../../../project/uikit/styles';
import css from '../Skeleton.module.scss';
const RenderElemet = ({ element, itemsShiners, darkMode }) => {
    const type = typeof element === 'string' ? element : element?.type;
    const properties = typeof element === 'string' ? {} : element;

    const margins =
        properties?.gap || properties?.gap === 0
            ? ['t', 'r', 'b', 'l'].reduce((acc, key, i) => {
                  return {
                      ...acc,
                      ...(properties?.gap === 0
                          ? uikit[`m${key}0`]
                          : properties?.gap[i]
                          ? uikit[`m${key}${properties?.gap[i]}`]
                          : {})
                  };
              }, {})
            : {};
    const width = properties?.width ? { width: `${properties?.width}%` } : {};
    const height = properties?.height ? { height: `${properties?.height}px` } : {};
    const align =
        properties?.align === 'center'
            ? { marginLeft: 'auto', marginRight: 'auto' }
            : properties?.align === 'right'
            ? { marginLeft: 'auto' }
            : {};
    const diameter = properties?.diameter
        ? {
              width: `${properties?.diameter}rem`,
              height: `${properties?.diameter}rem`
          }
        : {};

    if (type === 'table') {
        const colsTypes = [
            <div key={'colsTypes_table_1'} style={{ ...uikit.pr2, ...uikit.pl2 }}>
                <div
                    className={classNames(css.skeleton_text, darkMode && css.skeleton_dark_bg)}
                    style={{ width: '178px', ...uikit.mb1 }}
                />
                <div
                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_text)}
                    style={{ width: '107px', ...uikit.mb0 }}
                />
            </div>,
            <div
                key={'colsTypes_table_2'}
                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_text)}
                style={{
                    width: '140px',
                    ...uikit.mr2,
                    ...uikit.ml2
                }}
            />,
            <div
                key={'colsTypes_table_3'}
                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_text)}
                style={{
                    width: '63px',
                    ...uikit.mr2,
                    ...uikit.ml2
                }}
            />,
            <div
                key={'colsTypes_table_4'}
                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_text)}
                style={{
                    width: '250px',
                    ...uikit.mr2,
                    ...uikit.ml2
                }}
            />
        ];
        const getCols = (size) => {
            let array = [];
            for (let index = 0; index < size; index++) {
                array.push(<>{colsTypes[index] || colsTypes[colsTypes?.length % index]}</>);
            }
            return array;
        };
        const getRows = (size) => {
            let array = [];
            for (let index = 0; index < size; index++) {
                array.push(
                    <React.Fragment key={`getRows_${index}`}>
                        <div
                            style={{
                                ...uikit.flexRow,
                                ...uikit.alignItemsCenter,
                                ...uikit.justifyContentBetween
                            }}
                        >
                            {getCols(properties?.size?.columns).map((item) => item)}
                        </div>
                        <div
                            className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_line)}
                            style={{
                                width: 'calc(100% - 1rem)',
                                ...uikit.mb3,
                                ...uikit.mt3,
                                ...uikit.mr2,
                                ...uikit.ml2
                            }}
                        />
                    </React.Fragment>
                );
            }
            return array;
        };
        return (
            <div
                style={{
                    overflow: 'hidden',
                    width: width?.width || '100%',
                    ...align,
                    ...margins
                }}
            >
                <div className={css['skeleton_table_wrapper']} style={{ ...uikit.mr2_minus, ...uikit.ml2_minus }}>
                    <div className={css['skeleton_table_header']} style={{ ...uikit.mr2, ...uikit.ml2 }} />
                    {getRows(properties?.size?.rows).map((item) => item)}
                </div>
            </div>
        );
    }
    if (type === 'chart') {
        const getLine = (size) => {
            let array = [];
            for (let index = 0; index < size; index++) {
                array.push(
                    <React.Fragment key={`getLine_${index}`}>
                        {index === 0 ? (
                            <div
                                style={{
                                    ...uikit.flexColumn,
                                    ...uikit.justifyContentBetween
                                }}
                            >
                                <div
                                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                    style={{ width: '1rem', height: '1rem' }}
                                />
                                <div
                                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                    style={{ width: '1rem', height: '1rem' }}
                                />
                                <div
                                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                    style={{ width: '1rem', height: '1rem' }}
                                />
                                <div
                                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                    style={{ width: '1rem', height: '1rem' }}
                                />
                                <div
                                    className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                    style={{
                                        width: '1rem',
                                        height: '1rem',
                                        ...uikit.mr3
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                style={{
                                    width: '1rem',
                                    'min-width': '1rem',
                                    height: 'auto',
                                    ...uikit.mr3
                                }}
                            />
                        )}
                    </React.Fragment>
                );
            }
            return array;
        };

        return (
            <div
                style={{
                    ...uikit.flexRow,
                    ...width,
                    ...align,
                    ...margins,
                    ...diameter,
                    height: '200px',
                    overflow: 'hidden'
                }}
            >
                <div style={{ ...uikit.flexRow, ...uikit.justifyContentBetween }}>{getLine(40).map((item) => item)}</div>
            </div>
        );
    }
    if (type === 'list') {
        const getRows = (size, widthArray = []) => {
            let array = [];
            for (let index = 0; index < size; index++) {
                const width = widthArray[index] ? { width: `${widthArray[index]}%` } : {};
                array.push(
                    <React.Fragment key={`getRows_${index}`}>
                        <div
                            style={{
                                ...uikit.flexRow,
                                ...uikit.alignItemsCenter,
                                ...uikit.justifyContentBetween,
                                ...width
                            }}
                        >
                            <div
                                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_icon)}
                                style={{
                                    width: '1rem',
                                    height: '1rem',
                                    ...uikit.mr1
                                }}
                            />
                            <div
                                className={classNames(darkMode ? css.skeleton_dark_bg : '', css.skeleton_small)}
                                style={{ ...uikit.flexGrow1 }}
                            />
                        </div>
                    </React.Fragment>
                );
            }
            return array;
        };

        return (
            <div
                style={{
                    ...width,
                    ...align,
                    ...margins,
                    ...diameter
                }}
            >
                {getRows(properties?.size?.rows, properties?.size?.width).map((item) => item)}
            </div>
        );
    }

    if (type === 'course-client') {
        return '';
    }
    return (
        <div
            className={classNames(
                css[`skeleton_${type}`],
                darkMode ? css.skeleton_dark_bg : '',
                properties?.mode ? css[`skeleton_mode_${properties?.mode}`] : ''
            )}
            style={{
                ...width,
                ...height,
                ...margins,
                ...align,
                ...diameter,
                ...(itemsShiners ? { ...uikit.positionRelative, overflow: 'hidden' } : {})
            }}
        >
            {itemsShiners ? <div className={css.shine} /> : null}
        </div>
    );
};
export default RenderElemet;
